/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const CmpSplashprogress = ({ status, className, progress = 0 }) => {
  return (
    <div className={`cmp-splashprogress ${className}`}>
      <div 
        className="cmp-splashprogress-fill"
        style={{ 
          width: `${progress}%`,
          transition: 'width 0.1s ease-out'
        }}
      />
    </div>
  );
};

CmpSplashprogress.propTypes = {
  status: PropTypes.oneOf(["loading"]),
  progress: PropTypes.number,
};
